import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Lock, ShieldCheck, Sparkles } from 'lucide-react';
import { LANDING_SECTION_IDS } from './constants';

const TRUST_ITEMS = [
  {
    icon: ShieldCheck,
    title: 'Member safety',
    description: 'Granular permissions and community controls help you manage who sees what.',
  },
  {
    icon: Lock,
    title: 'Privacy first',
    description: 'Your community data stays within your control with clear privacy policies.',
  },
  {
    icon: Sparkles,
    title: 'White-label ready',
    description: 'Run Milora under your own brand with custom logos and landing pages.',
  },
] as const;

export function TrustSection() {
  return (
    <section id={LANDING_SECTION_IDS.trust} className="py-24 scroll-mt-24">
      <div className="container px-6 mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-12 space-y-4">
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight">Trust & safety</h2>
          <p className="text-muted-foreground text-lg">
            Built for community owners who need reliability, control, and transparency.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {TRUST_ITEMS.map((item, index) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.06 }}
              className="rounded-2xl border border-border/50 bg-muted/30 p-6 text-center"
            >
              <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-primary/10 text-primary">
                <item.icon className="h-6 w-6" />
              </div>
              <h3 className="font-bold text-foreground">{item.title}</h3>
              <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
                {item.description}
              </p>
            </motion.div>
          ))}
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 text-sm">
          <Link
            to="/privacy"
            className="font-medium text-muted-foreground hover:text-primary transition-colors"
          >
            Privacy Policy
          </Link>
          <Link
            to="/csae"
            className="font-medium text-muted-foreground hover:text-primary transition-colors"
          >
            CSAE Standards
          </Link>
          <Link
            to="/contact"
            className="font-medium text-muted-foreground hover:text-primary transition-colors"
          >
            Contact Support
          </Link>
        </div>
      </div>
    </section>
  );
}
